/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumShow.vue?vue&type=template&id=0b8f6b73&scoped=true"
import script from "./ForumShow.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumShow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumShow.vue?vue&type=style&index=0&id=0b8f6b73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f6b73",
  null
  
)

export default component.exports